import { Archive, Plus } from "lucide-react";
import { api } from "@/data/api";
import { useAsync } from "@/hooks/useAsync";
import { PageHeader, StatusBadge, DataTable, DemoBadge, AsyncBoundary, RowsSkeleton } from "@/components/common";
import { Button } from "@/components/ui/button";
import { demoAction } from "@/lib/demo";

export default function Backups() {
  const { data, loading, error } = useAsync(() => api.getBackups());
  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader icon={Archive} title="Backups" description="Snapshots e backups incrementais dos projetos e volumes."
        breadcrumb={<><span>Infraestrutura</span><span>/</span><span className="text-foreground">Backups</span></>}
        actions={<><DemoBadge className="hidden sm:inline-flex" /><Button onClick={() => demoAction("Backup Agora")} className="bg-brand text-white hover:bg-brand-hover" data-testid="backup-now"><Plus className="h-4 w-4" /> Backup Agora</Button></>} />
      <AsyncBoundary loading={loading} error={error} skeleton={<RowsSkeleton />}>
        <DataTable
          columns={[
            { key: "id", header: "ID", render: (r) => <span className="font-mono text-xs">{r.id}</span> },
            { key: "target", header: "Alvo", render: (r) => <span className="font-medium text-foreground">{r.target}</span> },
            { key: "project", header: "Projeto" },
            { key: "type", header: "Tipo" },
            { key: "size", header: "Tamanho", align: "right" },
            { key: "when", header: "Quando" },
            { key: "status", header: "Status", render: (r) => <StatusBadge status={r.status} size="sm" /> },
          ]}
          rows={data} testid="backups-table" />
      </AsyncBoundary>
    </div>
  );
}
